export const GENDER = {
  MALE: 'Masculino',
  FEMALE: 'Femenino',
};

/** String values for formSelectService and similar helpers. */
export const GENDER_OPTIONS = [GENDER.MALE, GENDER.FEMALE];

/** Semantic UI Select option objects. */
export const GENDER_SELECT_OPTIONS = GENDER_OPTIONS.map((opt) => ({
  key: opt,
  text: opt,
  value: opt,
}));
